import {
    AfterViewInit,
    Component,
    Inject,
    Input,
    NgZone,
    OnChanges,
    OnDestroy,
    PLATFORM_ID, SimpleChanges
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import * as am4core from '@amcharts/amcharts4/core';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import * as am4charts from '@amcharts/amcharts4/charts';


@Component({
    selector: 'zp-linear-chart',
    templateUrl: './linear-chart.component.html',
    styleUrls: ['./linear-chart.component.scss'],
    standalone: false
})
export class LinearChartComponent implements OnDestroy, AfterViewInit, OnChanges {
    @Input() id: string;
    @Input() data: any;
    @Input() height = 350;
    @Input() createSeries: (chart: am4charts.XYChart) => void;

    private chart: am4charts.XYChart;

    constructor(
        @Inject(PLATFORM_ID) private platformId: any, private zone: NgZone,
    ) {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.data && changes.data.previousValue && this.chart) {
            const curr = JSON.stringify(changes.data.previousValue);
            const prev = JSON.stringify(changes.data.currentValue);
            if (curr !== prev || !this.chart.data) {
                this.chart.data = this.data;
            }
        }
    }

    ngAfterViewInit() {
        // Chart code goes in here
        this.browserOnly(() => {
            am4core.useTheme(am4themes_animated);

            const chart = am4core.create(this.id, am4charts.XYChart);
            this.createSeries(chart);

            chart.paddingRight = 20;
            chart.data = this.data;
            chart.legend = new am4charts.Legend();
            chart.cursor = new am4charts.XYCursor();
            chart.language.locale["AM"] = "am";
            chart.language.locale["PM"] = "pm";

            this.chart = chart;

        });
    }

    ngOnDestroy() {
        // Clean up chart when the component is removed
        this.browserOnly(() => {
            if (this.chart) {
                this.chart.dispose();
            }
        });
    }

    // Run the function only in the browser
    browserOnly(f: () => void) {
        if (isPlatformBrowser(this.platformId)) {
            this.zone.runOutsideAngular(() => {
                f();
            });
        }
    }

}
